import axios from 'axios';
import { defaultOptions } from '../../../ui-lottery/src/api/helpers';

/**
 * !! Using this custom apiHelper which will allow crating custom authentication methods much easier
 *
 * Primary difference is the requirement of a authHeaders(headers: {}) method instead of getAuthHeaders() method
 *
 * Generate API helper methods incorporating authentication headers from the provided securityHelper
 * @param {Function} An authHeaders(headers: {}) function that returns an object of HTTP headers for axios
 * @return {*} API helper functions wrapping Axios HTTP methods (get, post, put, delete as remove)
 */
export const apiHelpers = (authHeaders) => {
  const get = (url, options = defaultOptions) => axios.get(url, options);
  const post = (url, data, options = defaultOptions) => axios.post(url, data, options);
  const put = (url, data, options = defaultOptions) => axios.put(url, data, options);
  const remove = (url, options = defaultOptions) => axios.delete(url, options);

  return {
    get,
    post,
    put,
    remove,
    getWithAuth(url, options = defaultOptions) {
      return get(url, { ...options, headers: authHeaders(options.headers) });
    },
    postWithAuth(url, data, options = defaultOptions) {
      return post(url, data, { ...options, headers: authHeaders(options.headers) });
    },
    putWithAuth(url, data, options = defaultOptions) {
      return put(url, data, { ...options, headers: authHeaders(options.headers) });
    },
    removeWithAuth(url, options = defaultOptions) {
      return remove(url, { ...options, headers: authHeaders(options.headers) });
    }
  };
};
